import { render, staticRenderFns } from "./DialogEditRate.vue?vue&type=template&id=17fb5b37&scoped=true"
import script from "./DialogEditRate.vue?vue&type=script&lang=js"
export * from "./DialogEditRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fb5b37",
  null
  
)

export default component.exports